<template>
  <div
    class="fixed w-full overflow-hidden border-l border-[#dedede] dark:border-[#353843] py-8"
  >
    <div
      class="absolute filter blur-3xl opacity-50 mix-blend-multiply top-12 left-[60px] bg-indigo-700 w-32 h-32 rounded-full"
    ></div>
    <div
      class="absolute filter blur-3xl opacity-30 mix-blend-multiply top-1/2 left-1/2 bg-fire w-[200px] h-[200px] rounded-full"
    ></div>
    <div class="relative z-10 flow-root w-full">
      <div class="w-full">
        <h2
          class="flex flex-row space-x-4 dark:text-white text-[28px] font-medium items-center"
        >
          <span>
            <svg width="23.001" height="23.001" viewBox="0 0 23.001 23.001">
              <defs>
                <linearGradient
                  id="linear-gradient"
                  x1="-0.174"
                  y1="0.5"
                  x2="1.215"
                  y2="0.5"
                  gradientUnits="objectBoundingBox"
                >
                  <stop offset="0" stop-color="#ed1b24" />
                  <stop offset="1" stop-color="#f97643" />
                </linearGradient>
              </defs>
              <g
                id="Group_1323"
                data-name="Group 1323"
                transform="translate(-950.637 -69.726)"
              >
                <g
                  id="Iconly_Bold_Chat"
                  data-name="Iconly/Bold/Chat"
                  transform="translate(950.637 69.726)"
                >
                  <g id="Chat">
                    <path
                      id="Chat-2"
                      data-name="Chat"
                      d="M11.5,23a11.449,11.449,0,0,1-5.659-1.5,2.528,2.528,0,0,0-1.273-.488,1.4,1.4,0,0,0-.44.073l-2.324.691a.867.867,0,0,1-.26.041.713.713,0,0,1-.575-.275.745.745,0,0,1-.108-.664l.771-2.58a1.2,1.2,0,0,0-.081-1.036A12.152,12.152,0,0,1,0,11.518,11.682,11.682,0,0,1,3.256,3.487,11.374,11.374,0,0,1,11.523,0a11.346,11.346,0,0,1,8.189,3.444A11.567,11.567,0,0,1,22.126,7.1,11.374,11.374,0,0,1,23,11.483a11.66,11.66,0,0,1-.995,4.8,11.039,11.039,0,0,1-2.616,3.626A11.782,11.782,0,0,1,11.5,23Zm5.279-12.946a1.474,1.474,0,1,0,1.472,1.474A1.475,1.475,0,0,0,16.779,10.056Zm-5.324,0a1.458,1.458,0,0,0-1.45,1.463,1.472,1.472,0,1,0,1.472-1.463h-.022Zm-5.28,0A1.474,1.474,0,1,0,7.648,11.53,1.475,1.475,0,0,0,6.176,10.056Z"
                      fill="url(#linear-gradient)"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </span>
          <span class="tracking-wide">{{
            t("application.conversations")
          }}</span>
        </h2>
        <p class="text-navada py-2 text-base text-[14px] dark:text-[#7f8a9e]">
          {{ t("application.process") }}
        </p>
        <div class="w-full h-[1px] bg-[#cbced2] dark:bg-[#353843] mt-6"></div>
      </div>
      <div class="overflow-y-auto h-all-msg">
        <ul
          role="list"
          class="py-2 pr-4 space-y-4 overflow-x-hidden overflow-y-auto"
        >
          <li
            v-for="item in items"
            :key="item.id"
            :class="[item.from === 'client' ? 'items-end' : 'items-start']"
            class="flex flex-col w-full px-0 py-2"
          >
            <ClientConversation v-if="item.from === 'client'" :item="item" />
            <EloConversation v-if="item.from === 'elo'" :item="item" />
          </li>
          <li ref="chat"></li>
        </ul>
      </div>

      <form
        @keyup.shift.enter="onSubmit"
        @submit.prevent="onSubmit"
        class="h-[52px] border-[#eaeaea] border-[2px] dark:border-transparent bg-white dark:bg-[#2f2e39] dark:text-white rounded-[12px] w-[90%] md:w-[50%] lg:w-[42%] xl:w-[38%] p-[2px] fixed b-all-msg flex flex-row justify-center items-center space-x-2"
      >
        <input
          type="text"
          :placeholder="t('input.type')"
          required
          v-model="message"
          class="flex rounded-lg w-full h-[48px] text-xl border-transparent text-vulcan dark:text-white bg-white dark:bg-transparent dark:border-transparent focus:ring-0 border-[2px] focus focus:border-[#ee2026] dark:focus:border-gold"
       />
        <button type="submit" class="pr-4">
          <svg
            class="hidden dark:block"
            width="24.136"
            height="20.804"
            viewBox="0 0 24.136 20.804"
          >
            <path
              id="send_icooon"
              data-name="send icooon"
              d="M1.438.114A1.907,1.907,0,0,0,.187,1.3a1.619,1.619,0,0,0-.167.966c.095.505,3.394,7.311,3.608,7.444.272.168,11.741,1.07,11.98.942a.533.533,0,0,0,.2-.821c-.225-.343-.03-.318-6.443-.827-2.706-.215-4.956-.428-5-.474s-.776-1.52-1.626-3.274C1.351,2.4,1.2,2.035,1.333,1.753a.8.8,0,0,1,1.028-.411c.173.064,4.819,2,10.324,4.3,10.8,4.513,10.458,4.338,10.079,5.109-.136.277-1.639.94-10.431,4.6-11.081,4.615-10.65,4.47-11,3.7-.128-.28.039-.685,1.589-3.87,1.524-3.132,1.715-3.594,1.594-3.86-.111-.243-.217-.294-.547-.263-.4.039-.439.1-2.128,3.508C.895,16.472.083,18.217.037,18.441a2.076,2.076,0,0,0,2.45,2.313c.243-.059,5.011-2.016,10.6-4.35,7.963-3.327,10.227-4.322,10.494-4.612a2.008,2.008,0,0,0,0-2.781c-.268-.292-2.52-1.277-10.62-4.646C7.3,2.013,2.506.056,2.3.015A1.958,1.958,0,0,0,1.438.114Z"
              fill="#f9d493"
              fill-rule="evenodd"
            />
          </svg>
          <svg
            class="dark:hidden"
            width="24.136"
            height="20.804"
            viewBox="0 0 24.136 20.804"
          >
            <path
              id="send_icooon"
              data-name="send icooon"
              d="M1.438.114A1.907,1.907,0,0,0,.187,1.3a1.619,1.619,0,0,0-.167.966c.095.505,3.394,7.311,3.608,7.444.272.168,11.741,1.07,11.98.942a.533.533,0,0,0,.2-.821c-.225-.343-.03-.318-6.443-.827-2.706-.215-4.956-.428-5-.474s-.776-1.52-1.626-3.274C1.351,2.4,1.2,2.035,1.333,1.753a.8.8,0,0,1,1.028-.411c.173.064,4.819,2,10.324,4.3,10.8,4.513,10.458,4.338,10.079,5.109-.136.277-1.639.94-10.431,4.6-11.081,4.615-10.65,4.47-11,3.7-.128-.28.039-.685,1.589-3.87,1.524-3.132,1.715-3.594,1.594-3.86-.111-.243-.217-.294-.547-.263-.4.039-.439.1-2.128,3.508C.895,16.472.083,18.217.037,18.441a2.076,2.076,0,0,0,2.45,2.313c.243-.059,5.011-2.016,10.6-4.35,7.963-3.327,10.227-4.322,10.494-4.612a2.008,2.008,0,0,0,0-2.781c-.268-.292-2.52-1.277-10.62-4.646C7.3,2.013,2.506.056,2.3.015A1.958,1.958,0,0,0,1.438.114Z"
              fill="#ee2026"
              fill-rule="evenodd"
            />
          </svg>
        </button>
      </form>
    </div>
    <div class="absolute z-40 top-4 right-4">
      <button
        @click="$emit('close')"
        class="inline-flex text-white hover:text-fire trans font-bold outline transition-all text-sm justify-center items-center bg-[#dedede] dark:bg-[#31313b] w-[32px] h-[32px] rounded-full"
      >
        X
      </button>
    </div>
  </div>
</template>

<script>
import {CheckIcon} from "@heroicons/vue/solid";
import {onMounted, reactive, ref, toRefs} from "vue";
import {useI18n} from "vue-i18n";

import {TransitionRoot} from "@headlessui/vue";
import ClientConversation from "./conversations/ClientConversation";
import EloConversation from "./conversations/EloConversation";

export default {
    components: {
        ClientConversation,
        EloConversation,
        CheckIcon,
        TransitionRoot,
    },
    props: {
        items: {
            type: Object,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
    },
    setup(props, {emit}) {
        const state = reactive({
            errors: {show: false},
            loading: false,
            message: "",
        });

        const chat = ref(null);
        const {t} = useI18n();

        onMounted(() => {
            scroll();
        });

        const scroll = () => {
            chat.value.scrollIntoView({behavior: "smooth"});
        };

        const onSubmit = async () => {
            state.loading = true;

            try {
                await axios.post(`/applications/${props.id}/conversations`, {
                    message: state.message,
                });
                emit("update");
                clear();
            } catch (e) {
                state.errors = {show: true, error: e.response.data};
            }
        };

        const clear = () => {
            state.message = "";
            state.errors = {show: false};
            state.loading = false;

            setTimeout(() => {
                scroll();
            }, 200);
        };

        return {
            t,
            chat,
            ...toRefs(state),
            onSubmit,
        };
    },
};
</script>
